import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import NumberFormat from 'react-number-format';

// Local deps
import './RFFInputField.scss';

function RFFNumberInputField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  numberFormat,
  ...otherProps
}) {
  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <NumberFormat
            className="nf-rff-input-field__input form-control"
            format={numberFormat || false}
            mask="_"
            {...input}
            {...otherProps}
          />
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
    </div>
  );
}

RFFNumberInputField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6 },
  errorCol: { md: 3 },
  isRequired: false,
  numberFormat: '(###) ###-####',
};

RFFNumberInputField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  numberFormat: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default RFFNumberInputField;



// WEBPACK FOOTER //
// ./src/components/form/RFFNumberInputField/RFFNumberInputField.jsx